import 'rc-pagination/assets/index.css';
import React, {useState} from "react";
import {gql, useQuery} from "@apollo/client";
import Tools from "../../../../Tools";
import {connect} from "react-redux";
import {toggleSelectPlayer, setPagination, setExpandRow, clearSelections, setSort, setRefetch} from "../../../../store/actions/Dashboard/Watchlist/WatchlistActions";
import {Image} from "react-bootstrap";
import dustinWilliamsonAvatar from "../../../../assets/img/demo/dustin-williamson-avatar.png";

import '../../../../assets/sass/components/datatable/player-datatable.scss';
import DataTableBase from "../../../ui/data_tables/DataTableBase";
import PlayerSummary from "../../../ui/player_profile/PlayerSummary";
import {useMutation} from "@apollo/react-hooks";

class WatchlistDataTable extends DataTableBase {
    /**
     * Returns the table columns configurations.
     * @returns {{dataField: string, text: string, headerTitle: string, sort :boolean}[]} .
     * dataField: the dataField.
     * text: The column display name.
     * sort: Determine if column is sortable.
     * headerTitle:
     */
    columnsConfig = () => {
        return [
            {
                dataField: 'name',
                text: 'Player Name',
                sort: true,
                renderer: (player) => this.renderPlayer(player),
            }, {
                dataField: 'team',
                text: 'Team',
                sort: true,
            }, {
                dataField: 'position',
                text: 'Position',
                sort: true,
            }, {
                dataField: 'age',
                text: 'Age',
                sort: true,
            }, {
                dataField: 'marketValue',
                text: 'Market Value',
                sort: true,
            }, {
                dataField: 'matchesPlayed',
                text: 'Matches Played',
                sort: true,
            }
            , {
                dataField: 'minutesPlayed',
                text: 'Minutes Played',
            }, {
                dataField: 'birthCountry',
                text: 'Birth Country',
            }, {
                dataField: 'passportCountry',
                text: 'Passport Country',
            }, {
                dataField: 'foot',
                text: 'Foot',
            }, {
                dataField: 'height',
                text: 'Height',
            }, {
                dataField: 'weight',
                text: 'Weight',
            }, {
                dataField: 'onLoan',
                text: 'On Loan',
            },
        ];
    };

    renderPlayer = (player) => {
        return (
            <div className="player-avatar-name">
                <Image roundedCircle src={player.avatar}/>
                <span> {player.name} </span>
            </div>
        );
    };

    renderExpandedRow = (row, rowIndex) => {
        const {page, onExpanding} = this.props;

        return (
            <div className="expanded-table-row">
                <PlayerSummary id={row.playerId} page={page} onExpanding={(loading, error, done) => this.handleExpanding(row.id, loading, error, done)}/>
            </div>
        );
    };

    getSelectedRows = () => {
        const {selectedRows} = this.props;
        return selectedRows;
    };

    /**
     * Handle Expanding rows.
     * @param id The row id
     * @param loading
     * @param error
     * @param done
     */
    handleExpanding = (id, loading, error, done) => {
        const {onExpanding} = this.props;

        if (typeof onExpanding === 'function') {
            onExpanding(loading, error, done);
        }
    };

    /**
     * Extra classes for datatable.
     * @type {{table: string}} The extra classes.
     */
    extraClasses = {
        table: 'player-datatable',
    };
}


const WatchlistDataTableDataWrapper = props => {
    const FETCH_WATCHLIST_DATATABLE_QUERY = gql`
        query getWatchlist(
            $q: String,
            $skip: Int,
            $take: Int,
        ){
            watchlist: userWatchlist(
                q: $q,
                skip: $skip,
                take: $take
                user: "5e9c3e2c2e57ff7e65742d0c"
            ){
                total
                filteredFrom
                results {
                    id
                    player{
                        ...playerFields
                    }
                    careerStats{
                        ...careerStatsFields
                    }
                }
            }
        }

        fragment playerFields on PlayerModel{
            id
            avatar
            name
            position
            dob
            marketValue
            onLoan
            height
            weight
            foot
            overallScore
            wage
            team {
                name
            }
            careerStats{
                ...careerStatsFields
            }
            nationality{
                name
            }
            passport{
                name
            }
        }

        fragment careerStatsFields on CareerStatsModel{
            matchesPlayed
            minutesPlayed
        }
    `;


    const REMOVE_FROM_WATCH_LIST = gql`
        mutation RemoveFromWatchlist($players: [String!]!){
            removeFromWatchlist(
                players: $players
            )
        }
    `;


    // Reformat response.
    const formatter = (watchlist) => {
        if (!watchlist)
            return [];

        return watchlist.map(item => {
            const player = formatPlayer(item.player);
            return {
                id: item.id,
                playerId: player.id,
                ...player,
            }
        });
    };

    const formatPlayer = (player) => ({
        id: player.id,
        name: player.name,
        avatar: player?.avatar?.length ? player?.avatar : dustinWilliamsonAvatar,
        team: player.team.name,
        position: player.position,
        age: Tools.calculateAge(new Date(player.dob)),
        marketValue: Tools.formatterNumber(player.marketValue),
        matchesPlayed: player.careerStats[0]?.matchesPlayed,
        minutesPlayed: player.careerStats[0]?.minutesPlayed,
        birthCountry: player.nationality?.name,
        passportCountry: player.passport?.name,
        foot: Tools.capitalize(player.foot),
        height: player.height,
        weight: player.weight,
        onLoan: Tools.capitalize(Tools.yesNo(player.onLoan))
    });

    // Get filters values from props.
    const {search, tempSearch} = props;
    const [expanding, setExpanding] = useState(false);

    const {currentPage, pageSize} = props;
    const variables = {
        q: Tools.convertEmptyToNull(search),
        skip: (currentPage - 1) * pageSize,
        take: pageSize,
    };

    // Fetch data.
    const {loading: queryLoading, error, data, refetch} = useQuery(FETCH_WATCHLIST_DATATABLE_QUERY, {
        variables: variables,
        notifyOnNetworkStatusChange: true,
    });

    const [removeFromWatchList, {loading: removeLoading, error: removeError}] = useMutation(REMOVE_FROM_WATCH_LIST, {
        refetchQueries: [{query: FETCH_WATCHLIST_DATATABLE_QUERY, variables}],
        // awaitRefetchQueries: true,
    });


    const {sortField, sortOrder} = props;
    // TODO: Pass them to api

    // Update loading.
    const loading = queryLoading | removeLoading | expanding | search !== tempSearch;

    // Handle Delete
    const {shouldDelete, clearSelections, selectedPlayers} = props;
    if (shouldDelete && !loading && !removeError) {
        const players = selectedPlayers.map(item => item.id);
        removeFromWatchList({
            variables: {
                players: players
            }
        }).then((result) => {
            clearSelections()
        });
    }

    // Handle refetch
    const {shouldRefetch, clearRefetch} = props;
    if (shouldRefetch && !loading) {
        refetch({
            variables: variables
        }).then((result) => {
            clearRefetch()
        });
    }


    // Format data.
    const rows = formatter(data?.watchlist?.results);
    const filteredFrom = data?.watchlist?.filteredFrom;
    const total = data?.watchlist?.total;

    // Pass props.
    const feedbackProps = {
        loading: loading,
        error: error,
    };

    const {page} = props;
    const paginationProps = {
        page: page,
        currentPage: currentPage,
        pageSize: pageSize,
        total: total,
        filteredFrom: filteredFrom,
    };

    const {expandedRows} = props;
    const dataProps = {
        rows: rows,
        selectedRows: selectedPlayers,
        expandedRows: expandedRows,
    };

    const {setPagination, toggleSelectPlayer, setExpandRow, setSort} = props;
    const handlersProp = {
        // onExpanding: (loading, error, done) => setExpanding(loading),
        onPageChange: (pagination) => setPagination(pagination),
        onRowSelect: (row) => toggleSelectPlayer(row),
        onExpandRow: (row, isExpand) => setExpandRow(row, isExpand),
        onSort: (field, order) => setSort(field, order),
    };

    return (
        <WatchlistDataTable
            {...feedbackProps}
            {...paginationProps}
            {...dataProps}
            {...handlersProp}
            enableSelect={true}
        />
    );
};

const mapStateToProps = state => {
    return {
        selectedPlayers: state.watchlist.datatable.selectedPlayers,
        expandedRows: state.watchlist.datatable.expandedRows,

        currentPage: state.watchlist.datatable.currentPage,
        pageSize: state.watchlist.datatable.pageSize,
        search: state.watchlist.search,
        tempSearch: state.watchlist.tempSearch,

        shouldDelete: state.watchlist.shouldDelete,
        shouldRefetch: state.watchlist.shouldRefetch,

        sortField: state.watchlist.datatable.sortField,
        sortOrder: state.watchlist.datatable.sortOrder,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleSelectPlayer: (player) => dispatch(toggleSelectPlayer(player)),
        setPagination: (pagination) => dispatch(setPagination(pagination)),
        setExpandRow: (row, isExpand) => dispatch(setExpandRow(row, isExpand)),
        setSort: (field, order) => dispatch(setSort(field, order)),

        clearSelections: () => dispatch(clearSelections()),
        clearRefetch: () => dispatch(setRefetch(false)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WatchlistDataTableDataWrapper);
